import { z } from 'zod';

// Response schema for call-off diff
export const zodCallOffDiffResponseSchema = z.object({
  changedFields: z.record(z.string(), z.unknown()),
  fromVersion: z.number().int(),
  itemChanges: z.array(z.record(z.string(), z.unknown())),
  toVersion: z.number().int(),
});
